import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { AppState } from '../../reducers';

import * as S from './styles';

type OwnProps = {
  className?: string;
  children: React.ReactElement;
  scrollTopLimit?: number;
};

type StateProps = {
  showMobileSearchBar?: boolean;
};

type Props = OwnProps & StateProps;

const StickyPageHeader = ({
  className,
  children,
  scrollTopLimit = 400,
  showMobileSearchBar,
}: Props) => {
  const [showStickyHeader, setShowStickyHeader] = useState(
    scrollTopLimit === 0 || false
  );

  const handleScroll = useCallback(() => {
    if (scrollTopLimit === 0) setShowStickyHeader(true);
    else if (window.scrollY <= scrollTopLimit && showStickyHeader)
      setShowStickyHeader(false);
    else if (window.scrollY > scrollTopLimit && !showStickyHeader)
      setShowStickyHeader(true);
  }, [scrollTopLimit, showStickyHeader]);

  // Re-registers event listener every time the showStickyHeader state changes,
  // so the callback always gets fresh state.
  useEffect(() => {
    document.addEventListener('scroll', handleScroll);

    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll, showStickyHeader]);

  return (
    <S.StickyPageHeader
      className={className}
      visible={showStickyHeader}
      showMobileSearchBar={Boolean(showMobileSearchBar)}
    >
      {children}
    </S.StickyPageHeader>
  );
};

const mapStateToProps = (state: AppState) => ({
  showMobileSearchBar: state.areas.header.showSearchBar,
});

export default connect(mapStateToProps, null)(StickyPageHeader);
